import { Check } from 'lucide-react';
import type { CoachPhase } from '../../hooks/useAgentSession';

const PHASES: { key: CoachPhase; label: string }[] = [
  { key: 'setup', label: 'Setup' },
  { key: 'research', label: 'Research' },
  { key: 'analysis', label: 'Analysis' },
  { key: 'interview', label: 'Interview' },
  { key: 'tailoring', label: 'Tailoring' },
  { key: 'review', label: 'Review' },
  { key: 'export', label: 'Export' },
];

interface PhaseIndicatorProps {
  currentPhase: CoachPhase;
}

export default function PhaseIndicator({ currentPhase }: PhaseIndicatorProps) {
  const currentIndex = PHASES.findIndex((p) => p.key === currentPhase);

  return (
    <div className="flex items-center gap-1 px-4 py-3 bg-white border-b border-gray-200 overflow-x-auto">
      {PHASES.map((phase, index) => {
        const isComplete = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={phase.key} className="flex items-center">
            {index > 0 && (
              <div
                className={`w-6 h-px mx-1 ${
                  isComplete ? 'bg-blue-500' : 'bg-gray-200'
                }`}
              />
            )}
            <div className="flex items-center gap-1.5">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium transition-colors ${
                  isComplete
                    ? 'bg-blue-500 text-white'
                    : isCurrent
                      ? 'bg-blue-100 text-blue-700 ring-2 ring-blue-500'
                      : 'bg-gray-100 text-gray-400'
                }`}
              >
                {isComplete ? <Check className="w-3.5 h-3.5" /> : index + 1}
              </div>
              <span
                className={`text-xs font-medium whitespace-nowrap ${
                  isCurrent ? 'text-blue-700' : isComplete ? 'text-gray-700' : 'text-gray-400'
                }`}
              >
                {phase.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
